import { CobranzasAxios, COMPANY } from './config'

export const getDashboard = async (date) => {
  // date tiene que tener formato (DD/MM/YYYY)
  const res = await CobranzasAxios.get(`/dashboard/${COMPANY}/${date}`)
  return res.data
}
